const doc = [({"en":({"dining":"Dining", "bars":"Bars", "activities":"Activities", "entertainment":"Entertainment", "kidsAndTeens":"Kids & Teens", "spaAndFitness":"Spa & Fitness"})})];
module.exports = doc.length <= 1 ? doc[0] : doc;